module.exports = __webpack_public_path__ + "media/images/proof_links/wildberries-403287c43c99cd8eddfce9dd3e7c8a13.svg";